"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3336],{

/***/ 83336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





const HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7620), __webpack_require__.e(2732), __webpack_require__.e(4682), __webpack_require__.e(1576)]).then(__webpack_require__.bind(__webpack_require__, 9586)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(9586)]
  }
});

const HomeSellOffersContainer = _ref => {
  let {
    title,
    href,
    action,
    alt
  } = _ref;
  const offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.sell.offers);
  const defaultHref = '/offerte-auto';
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const offersList = offers.filter(offer => offer.code !== 'auto-promo');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeOffersList, {
    title: title,
    action: action,
    href: href || defaultHref,
    alt: alt || action,
    offers: offersList
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HomeSellOffersContainer);

/***/ })

}]);